import {
  Box,
  Container,
  Flex,
  Heading,
  Icon,
  Image,
  Link,
} from "@chakra-ui/react";
import Office from "../img/office.png";
import OfficeBg from "../img/office-bg.png";
import React from "react";
import { RightLongArrow } from "./Icons";
import ButtonTheme from "./ButtonTheme";

const Offices = ({location}) => {

  const handleButtonClick = () => {

    window.location.href = '/search';
  }
  return (
    <Box h={{ lg: "100vh", base: "70vh" }} pos={"relative"} bgImage={OfficeBg}>
      <Container maxW={"90%"} h={"100%"}>
        <Flex
          justifyContent={"center"}
          h={"100%"}
          w={{ lg: "45%", base: "100%" }}
          flexDir={"column"}
        >
          <Heading
            fontSize={{ xl: "7xl", lg: "6xl", base: "4xl" }}
            w={{ lg: "65%", md: "100%" }}
            color={"BrightTurquoise"}
            textAlign={{ md: "left", base: "center" }}
          >
            Medical Offices Made Easy
          </Heading>
          <Link
            href={"/search?address=" + location}
            display={{ md: "flex", base: "none" }}
            alignItems={"center"}
            color={"white"}
            justifyContent={"start"}
            mt={20}
            gap={2}
          >
            Spaces for lease
            <Icon as={RightLongArrow} w={"20%"} />
          </Link>
          <ButtonTheme
            btnText={"Spaces for lease"}
            handleButtonClick={handleButtonClick}
            chakraProps={{
              mt: 6,
              display: { md: "none", base: "block" },
            }}
          />
        </Flex>
        <Image
          display={{ md: "inline-block", base: "none" }}
          w={"40%"}
          src={Office}
          pos={"absolute"}
          right={0}
          top={"-200px"}
        />
      </Container>
    </Box>
  );
};

export default Offices;
